var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.cssProps)},[(_vm.name && _vm.name.startsWith('http'))?_c('img',{staticClass:"logo",attrs:{"src":_vm.name}}):_c('span',{staticClass:"logo"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }